import { HTTP } from '../core/http/http-token';
import Routing from '../core/router/router';

export default {
    methods: {
        hideControlBar(player) {
            player.addClass('vjs-control-bar-hide');
        },
        /**
         * Function to convert duration in 'HH:MM:SS' to number of seconds
         *
         * @function    durationToSeconds
         *
         * @param       duration
         * @returns     {number}
         */
        durationToSeconds (duration) {
          if(duration){
            let res = duration.split(":");
            if (res.length === 3) {
                return parseInt(res[2]) + (parseInt(res[1]) * 60) + (parseInt(res[0]) * 3600);
            } else if (res.length === 2) {
                return parseInt(res[1]) + (parseInt(res[0]) * 60);
            }}
            return 0;
        },
        /**
         * Function to convert number of seconds to duration with the format 'HH:MM:SS'
         *
         * @function    secondsToDuration
         *
         * @param       secs
         * @returns     {string}
         */
        secondsToDuration (secs) {
            let sec_num = parseInt(secs, 10);
            let hours   = Math.floor(sec_num / 3600) % 24;
            let minutes = Math.floor(sec_num / 60) % 60;
            let seconds = sec_num % 60;

            return [hours,minutes,seconds]
                .map(v => v < 10 ? "0" + v : v)
                .filter((v,i) => v !== "0" || i > 0)
                .join(":")
        },
        /**
         * Convert time (string) to seconds (number)
         *
         * @function    timeToSec
         */
        timeToSec(duration) {
          let timePortions;
          let time;
          if (duration.length === 8) {
            timePortions = duration.split(":");
            time = parseInt(timePortions[0]) * 3600 + parseInt(timePortions[1]) * 60 + parseInt(timePortions[2]);
            return (time);
          } else if (duration.length === 6) {
            timePortions = duration.split("");
            time = (parseInt(timePortions[0]) * 10 + parseInt(timePortions[1])) * 3600 + (parseInt(timePortions[2]) * 10 + parseInt(timePortions[3])) * 60 + parseInt(timePortions[4]) * 10 + parseInt(timePortions[5]);
            return (time);
          } else {
            return 0;
          }
        },
        /**
         * Show alert notification
         *
         * @function    sweetAlert
         *
         * @param message
         */
        sweetAlert (message) {
            let t = docShadow.getElementById("notif-action");
            t.innerText = message;
            t.className = "show";
            setTimeout(function () {
                t.className = t.className.replace("show", "");
            }, 3500);
        },
        /**
         * Add tech class to player's container
         *
         * @function    addTechTagToPlayer
         *
         * @param       player
         * @param       playerOptions
         */
        addTechTagToPlayer (player, playerOptions) {
            let currentTech = playerOptions.techOrder[0];
            if(player!== undefined)
            {
              if (currentTech !== undefined) {
                  player.classList.add('vjs-tech-' + currentTech)
              } else {
                  player.classList.add('vjs-tech-html5')
              }
            }
        },
        /**
         * Show posters if player is ready
         *
         * @function    showPlayerPoster
         *
         * @param       playerOptions
         */
        showPlayerPoster(playerOptions) {
            if (playerOptions.techOrder !== undefined ) {
                if (playerOptions.techOrder[0] === 'flash') {
                    let posters = docShadow.getElementsByClassName('vjs-poster');
                    for (let i=0; i < posters.length; i++) {
                        posters[i].classList.add('vjs-poster-show');
                    }
                }
            }
        },
        /**
         * Animation after add element (scroll to bottom of the list)
         *
         * @function    animateScroll
         *
         * @param       {Number} duration
         * @param       {String} selector
         */
        animateScroll(duration, selector) {
            let someElement = docShadow.querySelector(selector);
            let start = someElement.scrollTop;
            let end = someElement.scrollHeight;
            let change = end - start;
            let increment = 20;
            function easeInOut(currentTime, start, change, duration) {
                // by Robert Penner
                currentTime /= duration / 2;
                if (currentTime < 1) {
                    return change / 2 * currentTime * currentTime + start;
                }
                currentTime -= 1;
                return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
            }
            function animate(elapsedTime) {
                elapsedTime += increment;
                let position = easeInOut(elapsedTime, start, change, duration);
                someElement.scrollTop = position;
                if (elapsedTime < duration) {
                    setTimeout(function() {
                        animate(elapsedTime);
                    }, increment)
                }
            }
            animate(0);
        },
        /**
         * Clear the content of the ocal storage
         *
         * @function    clearLocalStorage
         */
        clearLocalStorage() {
            localStorage.removeItem("textAnnotationsList");
            localStorage.removeItem("selectedVideosList");
            localStorage.removeItem("selectedAudiosList");
        },
      isMobile() {
        return (
          navigator.userAgent.match(/Android/i) ||
          navigator.userAgent.match(/webOS/i) ||
          navigator.userAgent.match(/iPhone/i) ||
          navigator.userAgent.match(/iPad/i) ||
          navigator.userAgent.match(/iPod/i) ||
          navigator.userAgent.match(/BlackBerry/i) ||
          navigator.userAgent.match(/Windows Phone/i)
        );
      },
      handleUploadFile(file, type = 'survey') {
        const url = Routing.generate('api_media_post_video_attached_file');
        const config = {
          header: {
            'Content-Type': 'multipart/form-data',
          },
        };

        let formData = new FormData();
        formData.append('empApiFileForm[thumb]', file);
        formData.append('type', type);

        return new Promise((resolve, reject) => {
          HTTP(window.ApiToken)
            .post(url, formData, config)
            .then(response => {
              resolve(response);
            })
            .catch(err => {
              console.error(err);
              reject(err);
            });
        });
      }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/helper.js